// src/components/ConfirmCancel.jsx
import React from 'react';

const ConfirmCancel = ({ visible, onConfirm, onCancel }) => {
  if (!visible) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-highlight-light border border-highlight-dark rounded-2xl shadow-2xl p-6 max-w-sm w-full text-center">
        <h2 className="text-xl font-bold text-primary mb-2">Cancel Appointment</h2>
        <p className="text-neutral-dark mb-4">
          Would you like to cancel this appointment?
        </p>

        <div className="flex justify-center space-x-4">
          <button
            onClick={onCancel}
            className="px-5 py-2 rounded-xl text-white bg-neutral-dark hover:bg-neutral transition duration-200 font-medium"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-5 py-2 rounded-xl text-white bg-button hover:bg-button-light transition duration-200 font-medium"
          >
            Yes, Cancel appointment
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmCancel;
